import Vue from 'vue';
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import Vuetify from 'vuetify'
import 'element-ui/lib/theme-chalk/index.css';

//import UploaderPlugin  from '@syncfusion/ej2-vue-inputs';
import locale from 'element-ui/lib/locale/lang/en'
import BlockUIService from './Shared/BlockUIService.js';

import App from './App.vue';
import Layout from './components/Layout/Layout.vue';
import Login from './components/Login/Login.vue';
import Home from './components/Home/Home.vue';
import DataService from './Shared/DataService';
import Helper from './Shared/Helper';
import VueEllipseProgress from 'vue-ellipse-progress';


//Patients
import Patients from './components/Patients/Patients.vue';
import PatientsEncounters from './components/Patients/Encounters/Encounters.vue';

//Clinics
import Clinics from './components/Clinics/Clinics.vue';
import ClinicsAppointments from './components/Clinics/Appointments/Appointments.vue';

//Dentists
import Dentists from './components/Dentists/Dentists.vue';

//Pharmacies
import Pharmacies from './components/Pharmacies/Pharmacies.vue';

//Dictionaries
import Specializations from './components/Dictionaries/Specializations/Specializations.vue';
import Specialties from './components/Dictionaries/Specialties/Specialties.vue';
import PaymentMethods from './components/Dictionaries/PaymentMethods/PaymentMethods.vue';
import DentalServices from './components/Dictionaries/DentalServices/DentalServices.vue';


//Users
import Users from './components/Users/Users.vue';
import UsersProfile from './components/Users/Profile/Profile.vue';
import UsersNotifications from './components/Users/Notifications/Notifications.vue';




Vue.use(VueEllipseProgress);

Vue.use(Vuetify)
Vue.use(VueI18n);
Vue.use(VueRouter);
//Vue.use(UploaderPlugin);
Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

Vue.prototype.$http = DataService;
Vue.prototype.$blockUI = BlockUIService;
Vue.prototype.$helper = Helper;


export const eventBus = new Vue();


const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            component: Login,
         
        },
         {
            path: '/',
            component: App,
            children: [
                {
                    path: '',
                    component: Layout,
                    children: [
                        { path: 'Home', component: Home },

                        //Clinics
                        { path: 'Clinics', component: Clinics },
                        { path: 'ClinicsAppointments', component: ClinicsAppointments },

                        //Dentists
                        { path: 'Dentists', component: Dentists },

                        //Patients
                        { path: 'Patients', component: Patients },
                        { path: 'PatientsEncounters', component: PatientsEncounters },


                        //Pharmacies
                        { path: 'Pharmacies', component: Pharmacies },

                        //Dictionaries
                        { path: 'Specializations', component: Specializations },
                        { path: 'Specialties', component: Specialties },
                        { path: 'PaymentMethods', component: PaymentMethods },
                        { path: 'DentalServices', component: DentalServices },

                        //Users
                        { path: 'Users', component: Users },
                        { path: 'UsersProfile', component: UsersProfile },
                        { path: 'UsersNotifications', component: UsersNotifications },


                       
                       
                    ]
                },
            ],
        }
    ]
});

Vue.filter('toUpperCase', function (value) {
    if (!value) return '';
    return value.toUpperCase();
});

new Vue({
    router,
    render: h => {
        return h(App);
    }
}).$mount('#cpanel-management');
